import { Grid, Box, Typography } from "@mui/material";
import FilterPanel from "./filter-panel";
import { BOOKING_DATE_START_DATE } from "../../common/constants/date";
import { VisualMount, createFilters } from "cerulean-bi-react";
import { calculateComparisonDates } from "../../common/components/utils/comparisonDateRange";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import {
  selectDateComparison,
  selectStayDate,
  selectSummaryAlignmentToggle,
  selectSummaryBookingDate,
  //  selectBEFilters,
  selectSymmetricComparisonToggle,
  selectCurrency,
  selectPmsSync,
  selectBreakdown,
} from "../summary-tab/selectors";
import { removeDynamicX } from "../../../modules/common/components/utils/rmFilter.tsx";
import StayDatePicker from "../../common/components/stayDatePicker/index.jsx";
import { toast } from "react-toastify";
import { getEmbedToken } from "../../../utils/auth.js";
import useAuthStore from "../../../utils/authStore.js";
import { useHotelIdStore } from "../../../utils/hotelIdStore.js";
// import useAuthStore from "../../../utils/authStore.js";
// import { getEmbedToken } from "../../../utils/auth.js";

const formatDate = (date) => format(new Date(date), "yyyy-MM-dd");
const currentDate = new Date();

const SummaryWidget = () => {
  const renderTimes = useRef([]);
  const renderStartTimes = useRef({});
  const dispatch = useDispatch();
  const bookingDate = useSelector(selectSummaryBookingDate);
  const alignmentToggle = useSelector(selectSummaryAlignmentToggle);
  const symmetricComparisonToggle = useSelector(
    selectSymmetricComparisonToggle
  );
  const dateComparison = useSelector(selectDateComparison);
  const stayDate = useSelector(selectStayDate);
  //  const BEfilters = useSelector(selectBEFilters)
  const currencyType = useSelector(selectCurrency);
  const pmsSync = useSelector(selectPmsSync);
  const breakdown = useSelector(selectBreakdown);
  const hotelId = useHotelIdStore((state) => state.hotelId);

  const [BEfilters, setBEfilters] = useState({
    filters: {
      PMS_toggle: {
        target: {
          table: "consumption_deaggrecords",
          columns: "channel",
        },
        conditions: {
          operator: "NotIn",
          values: ["PMS"],
        },
      },
      Hotel_Dropdown: {
        target: {
          table: "dim_hotels",
          column: "HotelID",
        },
        conditions: {
          operator: "In",
          values: ["Hotel_5"],
        },
      },
      dynamic_PMS_toggle: {
        target: {
          table: "consumption_deaggrecords",
          columns: "channel",
        },
        conditions: {
          operator: "NotIn",
          values: ["PMS"],
        },
      },
      stayDateFilter_lower: {
        target: {
          table: "dim_sdate",
          columns: "StayDate",
        },
        conditions: {
          operator: "GreaterThanOrEqual",
          values: formatDate(currentDate),
        },
      },
      stayDateFilter_upper: {
        target: {
          table: "dim_sdate",
          columns: "StayDate",
        },
        conditions: {
          operator: "LessThanOrEqual",
          values: formatDate(currentDate),
        },
      },
      dynamic_stayDateFilter_lower: {
        target: {
          table: "measures",
          columns: "dynamic_measure",
        },
        conditions: {
          operator: "In",
          values: formatDate(currentDate),
        },
      },
      dynamic_stayDateFilter_upper: {
        target: {
          table: "measures",
          columns: "dynamic_measure",
        },
        conditions: {
          operator: "In",
          values: formatDate(currentDate),
        },
      },
      currencyFilter: {
        target: {
          table: "measures",
          columns: "dynamic_measure",
        },
        conditions: {
          operator: "In",
          values: ["USD"],
        },
      },
      bookingDateFilter_lower: {
        target: {
          table: "dim_bdate",
          columns: "BookingDate",
        },
        conditions: {
          operator: "GreaterThanOrEqual",
          values: formatDate(new Date(BOOKING_DATE_START_DATE)),
        },
      },
      bookingDateFilter_upper: {
        target: {
          table: "dim_bdate",
          columns: "BookingDate",
        },
        conditions: {
          operator: "LessThanOrEqual",
          values: formatDate(currentDate),
        },
      },
      comparisonTimeFilterStayDate_lower: {
        target: {
          table: "dim_sdate",
          columns: "StayDate",
        },
        conditions: {
          operator: "GreaterThanOrEqual",
          values: formatDate(
            currentDate.setFullYear(currentDate.getFullYear() - 1)
          ),
        },
      },
      comparisonTimeFilterStayDate_upper: {
        target: {
          table: "dim_sdate",
          columns: "StayDate",
        },
        conditions: {
          operator: "LessThanOrEqual",
          values: formatDate(
            currentDate.setFullYear(currentDate.getFullYear() - 1)
          ),
        },
      },
      dynamic_comparisonTimeFilterStayDate_lower: {
        target: {
          table: "measures",
          columns: "dynamic_measure",
        },
        conditions: {
          operator: "In",
          values: formatDate(
            currentDate.setFullYear(currentDate.getFullYear() - 1)
          ),
        },
      },
      dynamic_comparisonTimeFilterStayDate_upper: {
        target: {
          table: "measures",
          columns: "dynamic_measure",
        },
        conditions: {
          operator: "In",
          values: formatDate(
            currentDate.setFullYear(currentDate.getFullYear() - 1)
          ),
        },
      },
      comparisonTimeFilterBookingDate_lower: {
        target: {
          table: "dim_bdate",
          columns: "BookingDate",
        },
        conditions: {
          operator: "GreaterThanOrEqual",
          values: formatDate(
            new Date(BOOKING_DATE_START_DATE).setFullYear(
              currentDate.getFullYear() - 1
            )
          ),
        },
      },
      comparisonTimeFilterBookingDate_upper: {
        target: {
          table: "dim_bdate",
          columns: "BookingDate",
        },
        conditions: {
          operator: "LessThanOrEqual",
          values: formatDate(
            currentDate.setFullYear(currentDate.getFullYear() - 1)
          ),
        },
      },
      typeFilterSelected: {
        target: {
          table: "measures",
          columns: "type",
        },
        conditions: {
          operator: "In",
          values: ["selected"],
        },
      },
      typeFilterCompared: {
        target: {
          table: "measures",
          columns: "type",
        },
        conditions: {
          operator: "In",
          values: ["compared"],
        },
      },
    },
    compound: {
      compound_operator: "and",
      filters: [
        "PMS_toggle",
        "Hotel_Dropdown",
        {
          compound_operator: "or",
          filters: [
            {
              compound_operator: "and",
              filters: [
                "typeFilterSelected",
                {
                  compound_operator: "and",
                  filters: [
                    {
                      compound_operator: "and",
                      filters: ["stayDateFilter_lower", "stayDateFilter_upper"],
                    },
                    {
                      compound_operator: "and",
                      filters: [
                        "bookingDateFilter_lower",
                        "bookingDateFilter_upper",
                      ],
                    },
                  ],
                },
              ],
            },
            {
              compound_operator: "and",
              filters: [
                "typeFilterCompared",
                {
                  compound_operator: "and",
                  filters: [
                    {
                      compound_operator: "and",
                      filters: [
                        "comparisonTimeFilterStayDate_lower",
                        "comparisonTimeFilterStayDate_upper",
                      ],
                    },
                    {
                      compound_operator: "and",
                      filters: [
                        "comparisonTimeFilterBookingDate_lower",
                        "comparisonTimeFilterBookingDate_upper",
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  });
  const [BEFilters2, setBEfilters2] = useState({
    filters: {
      PMS_toggle: {
        target: {
          table: "consumption_deaggrecords",
          columns: "channel",
        },
        conditions: {
          operator: "NotIn",
          values: ["PMS"],
        },
      },
      Hotel_Dropdown: {
        target: {
          table: "dim_hotels",
          column: "HotelID",
        },
        conditions: {
          operator: "NotIn",
          values: ["Hotel_5"],
        },
      },
      dynamic_PMS_toggle: {
        target: {
          table: "consumption_deaggrecords",
          columns: "channel",
        },
        conditions: {
          operator: "NotIn",
          values: ["PMS"],
        },
      },
      stayDateFilter_lower: {
        target: {
          table: "dim_sdate",
          columns: "StayDate",
        },
        conditions: {
          operator: "GreaterThanOrEqual",
          values: formatDate(currentDate),
        },
      },
      stayDateFilter_upper: {
        target: {
          table: "dim_sdate",
          columns: "StayDate",
        },
        conditions: {
          operator: "LessThanOrEqual",
          values: formatDate(currentDate),
        },
      },
      dynamic_stayDateFilter_lower: {
        target: {
          table: "measures",
          columns: "dynamic_measure",
        },
        conditions: {
          operator: "In",
          values: formatDate(currentDate),
        },
      },
      dynamic_stayDateFilter_upper: {
        target: {
          table: "measures",
          columns: "dynamic_measure",
        },
        conditions: {
          operator: "In",
          values: formatDate(currentDate),
        },
      },
      currencyFilter: {
        target: {
          table: "measures",
          columns: "dynamic_measure",
        },
        conditions: {
          operator: "In",
          values: ["USD"],
        },
      },
      bookingDateFilter_lower: {
        target: {
          table: "dim_bdate",
          columns: "BookingDate",
        },
        conditions: {
          operator: "GreaterThanOrEqual",
          values: formatDate(new Date(BOOKING_DATE_START_DATE)),
        },
      },
      bookingDateFilter_upper: {
        target: {
          table: "dim_bdate",
          columns: "BookingDate",
        },
        conditions: {
          operator: "LessThanOrEqual",
          values: formatDate(currentDate),
        },
      },
      comparisonTimeFilterStayDate_lower: {
        target: {
          table: "dim_sdate",
          columns: "StayDate",
        },
        conditions: {
          operator: "GreaterThanOrEqual",
          values: formatDate(
            currentDate.setFullYear(currentDate.getFullYear() - 1)
          ),
        },
      },
      comparisonTimeFilterStayDate_upper: {
        target: {
          table: "dim_sdate",
          columns: "StayDate",
        },
        conditions: {
          operator: "LessThanOrEqual",
          values: formatDate(
            currentDate.setFullYear(currentDate.getFullYear() - 1)
          ),
        },
      },
      dynamic_comparisonTimeFilterStayDate_lower: {
        target: {
          table: "measures",
          columns: "dynamic_measure",
        },
        conditions: {
          operator: "In",
          values: formatDate(
            currentDate.setFullYear(currentDate.getFullYear() - 1)
          ),
        },
      },
      dynamic_comparisonTimeFilterStayDate_upper: {
        target: {
          table: "measures",
          columns: "dynamic_measure",
        },
        conditions: {
          operator: "In",
          values: formatDate(
            currentDate.setFullYear(currentDate.getFullYear() - 1)
          ),
        },
      },
      comparisonTimeFilterBookingDate_lower: {
        target: {
          table: "dim_bdate",
          columns: "BookingDate",
        },
        conditions: {
          operator: "GreaterThanOrEqual",
          values: formatDate(
            new Date(BOOKING_DATE_START_DATE).setFullYear(
              currentDate.getFullYear() - 1
            )
          ),
        },
      },
      comparisonTimeFilterBookingDate_upper: {
        target: {
          table: "dim_bdate",
          columns: "BookingDate",
        },
        conditions: {
          operator: "LessThanOrEqual",
          values: formatDate(
            currentDate.setFullYear(currentDate.getFullYear() - 1)
          ),
        },
      },
      typeFilterSelected: {
        target: {
          table: "measures",
          columns: "type",
        },
        conditions: {
          operator: "In",
          values: ["selected"],
        },
      },
      typeFilterCompared: {
        target: {
          table: "measures",
          columns: "type",
        },
        conditions: {
          operator: "In",
          values: ["compared"],
        },
      },
    },
    compound: {
      compound_operator: "and",
      filters: [
        "PMS_toggle",
        "Hotel_Dropdown",
        {
          compound_operator: "or",
          filters: [
            {
              compound_operator: "and",
              filters: [
                "typeFilterSelected",
                {
                  compound_operator: "and",
                  filters: [
                    {
                      compound_operator: "and",
                      filters: ["stayDateFilter_lower", "stayDateFilter_upper"],
                    },
                    {
                      compound_operator: "and",
                      filters: [
                        "bookingDateFilter_lower",
                        "bookingDateFilter_upper",
                      ],
                    },
                  ],
                },
              ],
            },
            {
              compound_operator: "and",
              filters: [
                "typeFilterCompared",
                {
                  compound_operator: "and",
                  filters: [
                    {
                      compound_operator: "and",
                      filters: [
                        "comparisonTimeFilterStayDate_lower",
                        "comparisonTimeFilterStayDate_upper",
                      ],
                    },
                    {
                      compound_operator: "and",
                      filters: [
                        "comparisonTimeFilterBookingDate_lower",
                        "comparisonTimeFilterBookingDate_upper",
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    dynamic_axis: {
      x_axis_column_name: "channel",
    },
  });
  const totalCharts = 25;
  const isEmpty = (obj) => {
    if (obj) return Object.keys(obj).length === 0;
    return true;
  };
  const embedToken = useAuthStore((state) => state.embedToken);

  const accessToken = useAuthStore((state) => state.accessToken);
  useEffect(() => {
    (async () => {
      if (
        !embedToken ||
        (embedToken?.expireAt &&
          new Date(embedToken?.expireAt).getTime() < Date.now())
      ) {
        const embedTokenRes = await getEmbedToken(accessToken);

        const expireAt = new Date(Date.now() + 15 * 60 * 1000).toISOString();
        useAuthStore.setState({
          embedToken: { token: embedTokenRes, expireAt },
        });
      }
    })();
  }, [BEFilters2, BEfilters]);

  useEffect(() => {
    const comparisonDates = calculateComparisonDates(
      stayDate,
      bookingDate,
      alignmentToggle,
      symmetricComparisonToggle,
      dateComparison
    );
    const comparisonStayDate = comparisonDates["adjustedStayDate"];
    const comparisonBookingDate = comparisonDates["adjustedBookingDate"];
    const BEfilterDefinitions = [
      {
        filterName: "PMS_toggle",
        table: "consumption_deaggrecords",
        column: "channel",
        operator: "NotIn",
        values: pmsSync ? [] : ["PMS"],
      },
      {
        filterName: "dynamic_PMS_toggle",
        table: "consumption_deaggrecords",
        column: "channel",
        operator: "NotIn",
        values: pmsSync ? [] : ["PMS"],
      },
      {
        filterName: "DateComparison",
        table: "test",
        column: "test",
        operator: "null",
        values: dateComparison,
      },
      ...(hotelId
        ? [
            {
              filterName: "Hotel_Dropdown",
              table: "dim_hotels",
              column: "HotelID",
              operator: "In",
              values: [hotelId],
            },
          ]
        : []),
      {
        filterName: "DynamicXaxis",
        table: "Divisions",
        column: "table",
        operator: "In",
        values: breakdown,
      },
      {
        filterName: "stayDateFilter_lower",
        table: "dim_sdate",
        column: "StayDate",
        operator: "GreaterThanOrEqual",
        values: stayDate["startDate"],
      },
      {
        filterName: "stayDateFilter_upper",
        table: "dim_sdate",
        column: "StayDate",
        operator: "LessThanOrEqual",
        values: stayDate["endDate"],
      },
      {
        filterName: "dynamic_stayDateFilter_lower",
        table: "measures",
        column: "dynamic_measure",
        operator: "In",
        values: stayDate["startDate"],
      },
      {
        filterName: "dynamic_stayDateFilter_upper",
        table: "measures",
        column: "dynamic_measure",
        operator: "In",
        values: stayDate["endDate"],
      },
      {
        filterName: "currencyFilter",
        table: "measures",
        column: "dynamic_measure",
        operator: "In",
        values: [currencyType["name"]],
      },
      {
        filterName: "bookingDateFilter_lower",
        table: "dim_bdate",
        column: "BookingDate",
        operator: "GreaterThanOrEqual",
        values: bookingDate["startDate"],
      },
      {
        filterName: "bookingDateFilter_upper",
        table: "dim_bdate",
        column: "BookingDate",
        operator: "LessThanOrEqual",
        values: bookingDate["endDate"],
      },
      {
        filterName: "comparisonTimeFilterStayDate_lower",
        table: "dim_sdate",
        column: "StayDate",
        operator: "GreaterThanOrEqual",
        values: comparisonStayDate["startDate"],
      },
      {
        filterName: "comparisonTimeFilterStayDate_upper",
        table: "dim_sdate",
        column: "StayDate",
        operator: "LessThanOrEqual",
        values: comparisonStayDate["endDate"],
      },
      {
        filterName: "dynamic_comparisonTimeFilterStayDate_lower",
        table: "measures",
        column: "dynamic_measure",
        operator: "In",
        values: comparisonStayDate["startDate"],
      },
      {
        filterName: "dynamic_comparisonTimeFilterStayDate_upper",
        table: "measures",
        column: "dynamic_measure",
        operator: "In",
        values: comparisonStayDate["endDate"],
      },
      {
        filterName: "comparisonTimeFilterBookingDate_lower",
        table: "dim_bdate",
        column: "BookingDate",
        operator: "GreaterThanOrEqual",
        values: comparisonBookingDate["startDate"],
      },
      {
        filterName: "comparisonTimeFilterBookingDate_upper",
        table: "dim_bdate",
        column: "BookingDate",
        operator: "LessThanOrEqual",
        values: comparisonBookingDate["endDate"],
      },
      {
        filterName: "typeFilterSelected",
        table: "measures",
        column: "type",
        operator: "In",
        values: ["selected"],
      },
      {
        filterName: "typeFilterCompared",
        table: "measures",
        column: "type",
        operator: "In",
        values: ["compared"],
      },
    ];

    const compound = {
      compound_operator: "and",
      filters: [
        "PMS_toggle",
        ...(hotelId ? ["Hotel_Dropdown"] : []),
        {
          compound_operator: "or",
          filters: [
            {
              compound_operator: "and",
              filters: [
                "typeFilterSelected",
                {
                  compound_operator: "and",
                  filters: [
                    {
                      compound_operator: "and",
                      filters: ["stayDateFilter_lower", "stayDateFilter_upper"],
                    },
                    {
                      compound_operator: "and",
                      filters: [
                        "bookingDateFilter_lower",
                        "bookingDateFilter_upper",
                      ],
                    },
                  ],
                },
              ],
            },
            {
              compound_operator: "and",
              filters: [
                "typeFilterCompared",
                {
                  compound_operator: "and",
                  filters: [
                    {
                      compound_operator: "and",
                      filters: [
                        "comparisonTimeFilterStayDate_lower",
                        "comparisonTimeFilterStayDate_upper",
                      ],
                    },
                    alignmentToggle
                      ? {
                          compound_operator: "and",
                          filters: [
                            "comparisonTimeFilterBookingDate_lower",
                            "comparisonTimeFilterBookingDate_upper",
                          ],
                        }
                      : {
                          compound_operator: "and",
                          filters: [
                            "bookingDateFilter_lower",
                            "bookingDateFilter_upper",
                          ],
                        },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };

    const visualBEFilters = createFilters(BEfilterDefinitions, compound);
    const visualBEFilters2 = removeDynamicX(visualBEFilters);

    //dispatch( summaryActions.setSummaryBEFilter( visualBEFilters ));
    setBEfilters(visualBEFilters);
    setBEfilters2(visualBEFilters2);
  }, [
    bookingDate,
    alignmentToggle,
    symmetricComparisonToggle,
    dateComparison,
    stayDate,
    currencyType,
    hotelId,
    breakdown,
    pmsSync,
    dispatch,
  ]);

  const handleChartError = (event) => {
    if (event.errorType === "CSV-Export")
      toast.error(
        <div>
          <div style={{ fontWeight: "bold", fontSize: 15, paddingBottom: 4 }}>
            Export Failed!
          </div>
          <div>
            <strong>{`Chart ID - ${event.chartId}`}</strong>
          </div>
          <div>{event.message}</div>
        </div>
      );
  };

  const handleLoading = (chartId) => {
    renderStartTimes.current[chartId] = performance.now();
  };

  const handleRendered = (chartId) => {
    const start = renderStartTimes.current[chartId];
    const end = performance.now();
    const duration = end - start;
    renderTimes.current.push({ chartId, duration });
    console.table({ chartId, duration });

    if (renderTimes.current.length === totalCharts) {
      const times = renderTimes.current.map((e) => e.duration);
      const min = Math.min(...times);
      const max = Math.max(...times);
      const minChartId = renderTimes.current.find(
        (e) => e.duration === min
      ).chartId;
      const maxChartId = renderTimes.current.find(
        (e) => e.duration === max
      ).chartId;

      const output = {
        min: { "chart id": minChartId, value: `${min} ms` },
        max: { "chart id": maxChartId, value: `${max} ms` },
      };
      console.table(output);
    }
  };
  return (
    embedToken && (
      <Box>
        <Box
          width={"100%"}
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"end"}
          padding={4}
        >
          <Box pr={4}>
            <StayDatePicker />
          </Box>
        </Box>
        <Box
          display={"flex"}
          direction="row"
          spacing={2}
          sx={{ height: "100%" }}
          mb={10}
          pb={10}
        >
          {/* Filter Panel */}
          <Grid
            item
            xs={2}
            cc={2.5}
            md={2}
            sx={{
              ml: {
                xs: 0,
                cc: 0.25,
                md: 1,
                lg: 3,
              },
            }}
          >
            <FilterPanel />
          </Grid>

          {!isEmpty(BEFilters2) && !isEmpty(BEfilters) && (
            <Box
              sx={{
                marginTop: 3,
                width: "100%",
                ml: 8,
                display: "flex",
                flexDirection: "column",
                gap: 4,
              }}
            >
              {/* Row 1 */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  bgcolor: "white",
                  padding: 4,
                  borderRadius: 4,
                  width: "99.5%",
                }}
              >
                {/* Group 1 */}
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" sx={{ textAlign: "left", mb: 2 }}>
                    Revenue (USD)
                  </Typography>
                  <Box>
                    <Box display={"flex"}>
                      <VisualMount
                        chartId="21022598"
                        renderMode="SSR"
                        filters={BEFilters2}
                        url={process.env.REACT_APP_URL_SERVER}
                        embedToken={embedToken.token}
                        onLoading={() => handleLoading("21022598")}
                        onRendered={() => handleRendered("21022598")}
                        width={150}
                        height={120}
                      />
                      <VisualMount
                        chartId="33228565"
                        renderMode="SSR"
                        filters={BEFilters2}
                        url={process.env.REACT_APP_URL_SERVER}
                        embedToken={embedToken.token}
                        onLoading={() => handleLoading("33228565")}
                        onRendered={() => handleRendered("33228565")}
                        width={100}
                        height={100}
                      />

                      <Box position={"relative"}>
                        <Box>
                          <VisualMount
                            chartId="23592712"
                            renderMode="SSR"
                            filters={BEFilters2}
                            url={process.env.REACT_APP_URL_SERVER}
                            embedToken={embedToken.token}
                            onLoading={() => handleLoading("23592712")}
                            onRendered={() => handleRendered("23592712")}
                            width={150}
                            height={120}
                          />
                        </Box>
                        <Box position={"absolute"} bottom={0} left={20}>
                          <VisualMount
                            chartId="17366121"
                            renderMode="SSR"
                            filters={BEFilters2}
                            url={process.env.REACT_APP_URL_SERVER}
                            embedToken={embedToken.token}
                            onLoading={() => handleLoading("17366121")}
                            onRendered={() => handleRendered("17366121")}
                            width={100}
                            height={68}
                          />
                        </Box>
                      </Box>
                    </Box>

                    <VisualMount
                      chartId="17685678"
                      renderMode="SSR"
                      filters={BEfilters}
                      url={process.env.REACT_APP_URL_SERVER}
                      embedToken={embedToken.token}
                      onLoading={() => handleLoading("17685678")}
                      onRendered={() => handleRendered("33228565")}
                      height={380}
                      width={480}
                      onError={handleChartError}
                    />
                  </Box>
                </Box>

                {/* Group 2 */}
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" sx={{ textAlign: "left", mb: 2 }}>
                    Occupied Rooms
                  </Typography>
                  <Box>
                    <Box display={"flex"}>
                      <VisualMount
                        chartId="17786356"
                        renderMode="SSR"
                        filters={BEfilters}
                        url={process.env.REACT_APP_URL_SERVER}
                        embedToken={embedToken.token}
                        onLoading={() => handleLoading("17786356")}
                        onRendered={() => handleRendered("17786356")}
                        width={150}
                        height={120}
                      />
                      <VisualMount
                        chartId="10157800"
                        renderMode="SSR"
                        filters={BEfilters}
                        url={process.env.REACT_APP_URL_SERVER}
                        embedToken={embedToken.token}
                        onLoading={() => handleLoading("10157800")}
                        onRendered={() => handleRendered("10157800")}
                        width={100}
                        height={100}
                      />

                      <Box position={"relative"}>
                        <Box>
                          <VisualMount
                            chartId="32668978"
                            renderMode="SSR"
                            filters={BEfilters}
                            url={process.env.REACT_APP_URL_SERVER}
                            embedToken={embedToken.token}
                            onLoading={() => handleLoading("32668978")}
                            onRendered={() => handleRendered("32668978")}
                            width={150}
                            height={120}
                          />
                        </Box>
                        <Box position={"absolute"} bottom={0} left={20}>
                          <VisualMount
                            chartId="87360123"
                            renderMode="SSR"
                            filters={BEfilters}
                            url={process.env.REACT_APP_URL_SERVER}
                            embedToken={embedToken.token}
                            onLoading={() => handleLoading("87360123")}
                            onRendered={() => handleRendered("87360123")}
                            width={100}
                            height={68}
                          />
                        </Box>
                      </Box>
                    </Box>

                    <VisualMount
                      chartId="43502180"
                      renderMode="SSR"
                      filters={BEfilters}
                      url={process.env.REACT_APP_URL_SERVER}
                      embedToken={embedToken.token}
                      onLoading={() => handleLoading("43502180")}
                      onRendered={() => handleRendered("43502180")}
                      height={380}
                      width={480}
                      onError={handleChartError}
                    />
                  </Box>
                </Box>

                {/* Group 3 */}
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" sx={{ textAlign: "left", mb: 2 }}>
                    Average Daily Rate(USD)
                  </Typography>
                  <Box>
                    <Box
                      display={"flex"}
                      justifyContent={"space-between"}
                      alignItems={"flex-end"}
                    >
                      <VisualMount
                        chartId="36291917"
                        renderMode="SSR"
                        filters={BEfilters}
                        url={process.env.REACT_APP_URL_SERVER}
                        embedToken={embedToken.token}
                        onLoading={() => handleLoading("36291917")}
                        onRendered={() => handleRendered("36291917")}
                        width={150}
                        height={120}
                      />

                      <Box position={"relative"}>
                        <Box>
                          <VisualMount
                            chartId="19236314"
                            renderMode="SSR"
                            filters={BEfilters}
                            url={process.env.REACT_APP_URL_SERVER}
                            embedToken={embedToken.token}
                            onLoading={() => handleLoading("19236314")}
                            onRendered={() => handleRendered("19236314")}
                            width={150}
                            height={120}
                          />
                        </Box>
                        <Box position={"absolute"} bottom={0} left={20}>
                          <VisualMount
                            chartId="11071697"
                            renderMode="SSR"
                            filters={BEfilters}
                            url={process.env.REACT_APP_URL_SERVER}
                            embedToken={embedToken.token}
                            onLoading={() => handleLoading("11071697")}
                            onRendered={() => handleRendered("11071697")}
                            width={100}
                            height={68}
                          />
                        </Box>
                      </Box>
                    </Box>

                    <VisualMount
                      chartId="20094257"
                      renderMode="SSR"
                      filters={BEfilters}
                      url={process.env.REACT_APP_URL_SERVER}
                      embedToken={embedToken.token}
                      onLoading={() => handleLoading("20094257")}
                      onRendered={() => handleRendered("20094257")}
                      height={380}
                      width={480}
                      onError={handleChartError}
                    />
                  </Box>
                </Box>
              </Box>
              {/* Row 2 */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  bgcolor: "white",
                  padding: 4,
                  borderRadius: 4,
                  width: "99.5%",
                }}
              >
                {/* Group 1 */}
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" sx={{ textAlign: "left", mb: 2 }}>
                    Cancellation Count
                  </Typography>
                  <Box>
                    <Box display={"flex"}>
                      <VisualMount
                        chartId="49343515"
                        renderMode="SSR"
                        filters={BEfilters}
                        url={process.env.REACT_APP_URL_SERVER}
                        embedToken={embedToken.token}
                        onLoading={() => handleLoading("49343515")}
                        onRendered={() => handleRendered("49343515")}
                        width={150}
                        height={120}
                      />

                      <Box position={"relative"}>
                        <Box>
                          <VisualMount
                            chartId="22869024"
                            renderMode="SSR"
                            filters={BEfilters}
                            url={process.env.REACT_APP_URL_SERVER}
                            embedToken={embedToken.token}
                            onLoading={() => handleLoading("22869024")}
                            onRendered={() => handleRendered("22869024")}
                            width={150}
                            height={120}
                          />
                        </Box>
                        <Box position={"absolute"} bottom={0} left={20}>
                          <VisualMount
                            chartId="37936617"
                            renderMode="SSR"
                            filters={BEfilters}
                            url={process.env.REACT_APP_URL_SERVER}
                            embedToken={embedToken.token}
                            onLoading={() => handleLoading("37936617")}
                            onRendered={() => handleRendered("37936617")}
                            width={100}
                            height={68}
                          />
                        </Box>
                      </Box>
                    </Box>

                    <VisualMount
                      chartId="32679065"
                      renderMode="SSR"
                      filters={BEfilters}
                      url={process.env.REACT_APP_URL_SERVER}
                      embedToken={embedToken.token}
                      onLoading={() => handleLoading("32679065")}
                      onRendered={() => handleRendered("32679065")}
                      height={380}
                      width={480}
                      onError={handleChartError}
                    />
                  </Box>
                </Box>

                {/* Group 2 */}
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" sx={{ textAlign: "left", mb: 2 }}>
                    Reservation Count
                  </Typography>
                  <Box>
                    <Box display={"flex"}>
                      <VisualMount
                        chartId="16122963"
                        renderMode="SSR"
                        filters={BEfilters}
                        url={process.env.REACT_APP_URL_SERVER}
                        embedToken={embedToken.token}
                        onLoading={() => handleLoading("16122963")}
                        onRendered={() => handleRendered("16122963")}
                        width={150}
                        height={120}
                      />

                      <Box position={"relative"}>
                        <Box>
                          <VisualMount
                            chartId="17355893"
                            renderMode="SSR"
                            filters={BEfilters}
                            url={process.env.REACT_APP_URL_SERVER}
                            embedToken={embedToken.token}
                            onLoading={() => handleLoading("17355893")}
                            onRendered={() => handleRendered("17355893")}
                            width={150}
                            height={120}
                          />
                        </Box>
                        <Box position={"absolute"} bottom={0} left={20}>
                          <VisualMount
                            chartId="91132626"
                            renderMode="SSR"
                            filters={BEfilters}
                            url={process.env.REACT_APP_URL_SERVER}
                            embedToken={embedToken.token}
                            onLoading={() => handleLoading("91132626")}
                            onRendered={() => handleRendered("91132626")}
                            width={100}
                            height={68}
                          />
                        </Box>
                      </Box>
                    </Box>

                    <VisualMount
                      chartId="20859626"
                      renderMode="SSR"
                      filters={BEfilters}
                      url={process.env.REACT_APP_URL_SERVER}
                      embedToken={embedToken.token}
                      onLoading={() => handleLoading("20859626")}
                      onRendered={() => handleRendered("20859626")}
                      height={380}
                      width={480}
                      onError={handleChartError}
                    />
                  </Box>
                </Box>

                {/* Group 3 */}
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" sx={{ textAlign: "left", mb: 2 }}>
                    Breakdown by Revenue
                  </Typography>
                  <Box>
                    <Box
                      display={"flex"}
                      justifyContent={"space-between"}
                      alignItems={"flex-end"}
                    >
                      <VisualMount
                        chartId="20168238"
                        renderMode="SSR"
                        filters={BEfilters}
                        url={process.env.REACT_APP_URL_SERVER}
                        embedToken={embedToken.token}
                        onLoading={() => handleLoading("20168238")}
                        onRendered={() => handleRendered("20168238")}
                        width={150}
                        height={120}
                      />
                      <VisualMount
                        chartId="10585969"
                        renderMode="SSR"
                        filters={BEfilters}
                        url={process.env.REACT_APP_URL_SERVER}
                        embedToken={embedToken.token}
                        onLoading={() => handleLoading("10585969")}
                        onRendered={() => handleRendered("10585969")}
                        width={100}
                        height={100}
                      />
                    </Box>

                    <VisualMount
                      chartId="31548952"
                      renderMode="SSR"
                      filters={BEfilters}
                      url={process.env.REACT_APP_URL_SERVER}
                      embedToken={embedToken.token}
                      onLoading={() => handleLoading("31548952")}
                      onRendered={() => handleRendered("31548952")}
                      height={400}
                      width={500}
                      onError={handleChartError}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    )
  );
};
export default SummaryWidget;
